// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2xk1Z","fadeIn":"index-fadeIn-RVSp0","closeBtn":"index-closeBtn-3sr5y","videoBg":"index-videoBg-3-Fj0","videoContainer":"index-videoContainer-1rHVn"};